import { HostingPageInformation } from '../utils/useCustomerPageInformation.hooks';
import { computed, ref } from '@vue/composition-api';
import { HostingService } from '@ligo/dashboard/customer/store';
import { HostingRequest } from '@ligo/dashboard/store';
export function useHosting() {
  const {
    t,
    isReady: isPageInformationReady,
    load: loadPageInformation
  } = HostingPageInformation;

  const loading = ref(false);
  const searchTerm = ref('');
  const hostingResponse = ref<HostingRequest[]>([]);

  const isLoading = computed(() => loading.value);

  const noResults = ref(false);

  function getHostingByTerm() {
    if (!searchTerm.value) {
      hostingResponse.value = [];
      return;
    }

    loading.value = true;
    HostingService.getHostingByTerm({ query: searchTerm.value })
      .then((response) => {
        hostingResponse.value = response.data;
        noResults.value = hostingResponse.value.length === 0;
      })
      .catch((e) => {
        console.error('There was an error fetching hosting requests', e);
      })
      .finally(() => {
        loading.value = false;
      });
  }

  function goToOrderLink(orderLink: string) {
    const separator = orderLink.includes('?') ? '&' : '?';
    const targetUrl = `${orderLink}${separator}utm_source=portal&utm_campaign=domaincheck&utm_id=ligo`;
    window.open(targetUrl, '_blank');
  }

  loadPageInformation();

  return {
    t,
    isPageInformationReady,
    isLoading,
    searchTerm,
    getHostingByTerm,
    hostingResponse,
    goToOrderLink,
    noResults
  };
}
